// Guard must be initialized before any early-dispatched handlers run.
let __applyingLoleImageFilter = false;
let __loleImageFilterQueued = null;

// Temporary: filter the console for [pdp-scroll], then change a size or color.
(function installPdpScrollDebug() {
  const tag = '[pdp-scroll]';
  const stack = () => new Error().stack.split('\n').slice(2, 8).map((line) => line.trim());
  const describe = (el) => el && {
    tag: el.tagName,
    id: el.id || '',
    name: el.name || '',
    type: el.type || '',
    value: el.value || '',
    className: String(el.className || '').slice(0, 100),
  };

  console.log(tag, 'installed', {
    src: document.currentScript && document.currentScript.src,
    width: window.innerWidth,
    scrollY: Math.round(window.scrollY),
  });

  const nativeScrollTo = window.scrollTo.bind(window);
  window.scrollTo = function () {
    const arg = arguments[0];
    console.log(tag, 'window.scrollTo', typeof arg === 'object' && arg
      ? { top: arg.top, left: arg.left, behavior: arg.behavior }
      : { x: arguments[0], y: arguments[1] }, 'from', Math.round(window.scrollY), stack());
    return nativeScrollTo.apply(window, arguments);
  };

  const nativeScroll = window.scroll.bind(window);
  window.scroll = function () {
    console.log(tag, 'window.scroll', { x: arguments[0], y: arguments[1] }, 'from', Math.round(window.scrollY), stack());
    return nativeScroll.apply(window, arguments);
  };

  const nativeScrollIntoView = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function (arg) {
    console.log(tag, 'scrollIntoView', describe(this), arg, 'scrollY', Math.round(window.scrollY), stack());
    return nativeScrollIntoView.apply(this, arguments);
  };

  const nativeFocus = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function (arg) {
    console.log(tag, 'focus', describe(this), { preventScroll: !!(arg && arg.preventScroll) }, 'scrollY', Math.round(window.scrollY), stack());
    return nativeFocus.apply(this, arguments);
  };

  // A smooth scroll to the top arrives in tiny steps, so a per-event threshold never prints.
  // Log the tap, then where the page is a moment later.
  document.addEventListener('pointerdown', (event) => {
    const target = event.target;
    const from = Math.round(window.scrollY);
    const option = target && target.closest && target.closest(
      'label, button, a, input, radio-swatch, [data-sibling-color-swatch], [data-single-option-selector], [data-sibling-sizes]'
    );
    console.log(tag, 'pointerdown', {
      target: describe(target),
      option: describe(option),
      scrollY: from,
    });
    setTimeout(() => {
      const to = Math.round(window.scrollY);
      console.log(tag, Math.abs(to - from) > 8 ? 'page moved after tap' : 'page stayed after tap', {
        from,
        to,
        active: describe(document.activeElement),
      });
    }, 700);
  }, true);

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!target || !target.closest || !target.closest('[data-product-form], .product__page, form')) return;
    console.log(tag, 'change', describe(target), 'scrollY', Math.round(window.scrollY));
  }, true);

  window.addEventListener('beforeunload', () => {
    console.log(tag, 'page unloading', window.location.href);
  });
})();

// add listener + fire event if selected
document.querySelectorAll('.radio__fieldset--swatches .radio__buttons input[type="radio"]').forEach(radio => {
  radio.addEventListener('change', hideOtherColorImages);
  if (radio.checked) {
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

// Update images when variant changes via theme events (e.g., deep-linked variant on load)
document.addEventListener('theme:variant:change', (e) => {
  console.log('[pdp-scroll] theme:variant:change', {
    scrollY: Math.round(window.scrollY),
    source: e?.detail?.source,
    variantId: e?.detail?.variant?.id,
    option1: e?.detail?.variant?.option1,
  });
  if (e?.detail?.source === 'siblings') return;
  // Run after theme's own handlers (which may switch media). Pass the event so we read
  // detail.variant (avoids races when other change listeners run before the hidden id input updates).
  setTimeout(() => hideOtherColorImages(e), 0);
}, { passive: true });

// (Removed) Re-applying on media select caused re-entrancy and flicker

// Scroll the horizontal mobile strip to a slide (scrollIntoView often scrolls the page, not the list).
function scrollProductMediaListToSlide(productImages, slideEl) {
  const list = productImages?.querySelector('[data-product-media-list]');
  if (!list || !slideEl) return;
  const apply = () => {
    const listRect = list.getBoundingClientRect();
    const slideRect = slideEl.getBoundingClientRect();
    const delta = slideRect.left - listRect.left;
    list.scrollLeft += delta;
  };
  requestAnimationFrame(() => requestAnimationFrame(apply));
}

// Filename segments plus data-color. NBA files are STYLE_TEAM_COLOR_SHOT,
// so the color code is not always the second segment stored in data-color.
function mediaColorTokens(el) {
  const tokens = [];
  const push = (value) => {
    const token = String(value || '').trim().toLowerCase();
    if (token && !tokens.includes(token)) tokens.push(token);
  };

  push(el.getAttribute('data-color'));

  const urls = [];
  el.querySelectorAll('img').forEach((img) => {
    urls.push(img.getAttribute('src') || '');
    urls.push(img.currentSrc || '');
  });
  const link = el.querySelector('a[href]');
  if (link) urls.push(link.getAttribute('href') || '');

  urls.forEach((src) => {
    const file = String(src).split('/').pop().split('?')[0].split('.')[0];
    file.split('_').forEach(push);
  });

  return tokens;
}

function mediaMatchesColor(el, colorCode) {
  const code = String(colorCode || '').trim().toLowerCase();
  if (!code) return false;
  return mediaColorTokens(el).includes(code);
}

// First in-flow slide of the current color spans the mosaic. Spanning whichever
// slide is .media--active leaves a hole when that slide is not first.
function markGalleryLead(root) {
  if (!root) return;
  let leadSet = false;
  root.querySelectorAll('.product__slide').forEach((slide) => {
    const hidden = slide.style.display === 'none' || slide.classList.contains('media--hidden');
    if (!hidden && !leadSet) {
      slide.classList.add('is-gallery-lead');
      leadSet = true;
    } else {
      slide.classList.remove('is-gallery-lead');
    }
  });
}

// Thumbnail faders show one slide at a time. Mosaic and stacked galleries show every match.
function galleryCollapsesToActiveSlide(productImages) {
  if (!productImages) return false;
  const isMobile = window.innerWidth < 750;
  if (isMobile) return productImages.hasAttribute('data-fader-mobile');
  return productImages.hasAttribute('data-fader-desktop');
}

// to get all images
function hideOtherColorImages(event) {
  const scrollYBefore = Math.round(window.scrollY);
  console.log('[pdp-scroll] hideOtherColorImages', {
    scrollY: scrollYBefore,
    eventType: event && event.type,
    variantId: event && event.detail && event.detail.variant && event.detail.variant.id,
    skipped: __applyingLoleImageFilter,
  }, new Error().stack);
  if (__applyingLoleImageFilter) { return; }
  if (__applyingLoleImageFilter) {
    __loleImageFilterQueued = event || __loleImageFilterQueued;
    return;
  }
  __applyingLoleImageFilter = true;
  try {
  const finalSaleInput = document.getElementById('final_price_property');
  if (finalSaleInput) {
    finalSaleInput.removeAttribute('name');
  }

  const productElem = document.querySelector('.product__page');
  if (!productElem) { return true; }

  // Derive color code from event variant, selected variant, or fallback to SKU
  let curColorCode = null;

  // 1) From event.detail.variant (preferred)
  const evVariant = event && event.detail && event.detail.variant ? event.detail.variant : null;
  if (evVariant && evVariant.option1) {
    const parts = String(evVariant.option1).trim().split(' ');
    curColorCode = parts[parts.length - 1];
  }

  // 2) From current variant input + product JSON
  if (!curColorCode) {
    try {
      const variantIdInput = document.querySelector('input[name="id"]');
      const variantId = variantIdInput && variantIdInput.value ? Number(variantIdInput.value) : null;
      const productDataElement = document.querySelector('[data-product-json]');
      if (variantId && productDataElement && productDataElement.textContent) {
        const productData = JSON.parse(productDataElement.textContent);
        const currentVariant = productData.variants && productData.variants.find(v => v.id === variantId);
        if (currentVariant && currentVariant.option1) {
          const parts = String(currentVariant.option1).trim().split(' ');
          curColorCode = parts[parts.length - 1];
        }
      }
    } catch (e) {
      // swallow
    }
  }

  // 3) Fallback from SKU format "...-CODE"
  if (!curColorCode) {
    const skuText = productElem.querySelector('.product__sku')?.textContent || '';
    const skuParts = skuText.split('-');
    if (skuParts.length > 1) {
      curColorCode = skuParts[1].trim();
    }
  }

  // 4) Fallback from current active media/thumbnail data-color
  if (!curColorCode) {
    const productImagesEl = document.querySelector('product-images');
    const activeSlide = productImagesEl?.querySelector('.product__slide.media--active');
    const activeThumb = document.querySelector('.product__thumb.is-active');
    const fallbackColor = (activeSlide?.getAttribute('data-color') || activeThumb?.getAttribute('data-color') || '').trim();
    if (fallbackColor) {
      curColorCode = fallbackColor;
    }
  }

  const productImages = document.querySelector('product-images');
  // If we don't have a color code yet, at least ensure the active slide is in view
  if (!curColorCode) {
    const activeEl = productImages?.querySelector('.product__slide.media--active');
    if (activeEl && productImages) {
      scrollProductMediaListToSlide(productImages, activeEl);
    }
    return true;
  }

  let firstVisible = null;
  const slides = Array.from(productElem.querySelectorAll('.product__slide'));
  const slidesToShow = slides.filter((image) => mediaMatchesColor(image, curColorCode));
  const collapseExtras = galleryCollapsesToActiveSlide(productImages);

  // Slides (clear fader transition class so we don't leave stale state from theme:media:select)
  slides.forEach(image => {
    image.classList.remove('media--hiding');
    const matchesColor = slidesToShow.includes(image);

    if (matchesColor) {
      image.style.display = '';
      if (!firstVisible) {
        image.classList.remove('media--hidden');
        firstVisible = image;
      } else if (collapseExtras) {
        image.classList.add('media--hidden');
        image.classList.remove('media--active');
      } else {
        image.classList.remove('media--hidden');
        image.classList.remove('media--active');
      }
    } else {
      image.classList.add('media--hidden');
      image.style.display = 'none';
      image.classList.remove('media--active');
    }
  });

  // Thumbs
  productElem.querySelectorAll('.product__thumb').forEach(image => {
    const matchesColor = mediaMatchesColor(image, curColorCode);
    image.style.display = matchesColor ? '' : 'none';
  });

  // Make first visible slide active and notify gallery
  if (firstVisible && productImages) {
    const active = productImages.querySelector('.product__slide.media--active');
    if (active && active !== firstVisible) {
      active.classList.remove('media--active');
    }
    firstVisible.classList.add('media--active');

    const mediaId = firstVisible.getAttribute('data-media-id');
    if (mediaId) {
      productImages.dispatchEvent(new CustomEvent('theme:media:select', { detail: { id: mediaId } }));
    }

    // Ensure the slider viewport shows the active (first visible) slide on mobile.
    // Scroll only the gallery strip. Moving the window pulls the shopper back to the main image.
    scrollProductMediaListToSlide(productImages, firstVisible);
  }

  } finally {
    // Always release the guard even on early returns/errors
    setTimeout(() => { __applyingLoleImageFilter = false; }, 0);
    setTimeout(() => {
      console.log('[pdp-scroll] after hideOtherColorImages', {
        before: scrollYBefore,
        after: Math.round(window.scrollY),
      });
    }, 500);
    markGalleryLead(document.querySelector('.product__page'));
    __applyingLoleImageFilter = false;
    if (__loleImageFilterQueued) {
      const queued = __loleImageFilterQueued;
      __loleImageFilterQueued = null;
      hideOtherColorImages(queued);
    }
  }
};

// Ensure initial state reflects the loaded variant (e.g., URL with variant ID)
hideOtherColorImages();

// On first load, ensure the initially-selected media (data-active-media) is displayed
function ensureActiveMediaInView() {
  const productImages = document.querySelector('product-images');
  if (!productImages) return;

  // Prefer the featured (data-active-media) slide first
  let targetId = productImages.getAttribute('data-active-media');
  let targetEl = targetId ? productImages.querySelector(`[data-media-id="${targetId}"]`) : null;

  // Fallback to first non-hidden slide
  if (!targetEl) {
    targetEl = productImages.querySelector('.product__slide:not(.media--hidden)');
    targetId = targetEl?.getAttribute('data-media-id') || null;
  }

  if (!targetEl) return;

  if (targetId) {
    productImages.dispatchEvent(new CustomEvent('theme:media:select', { detail: { id: targetId } }));
  }

  scrollProductMediaListToSlide(productImages, targetEl);
}

// Run after initial scripts bind
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  setTimeout(ensureActiveMediaInView, 0);
  setTimeout(ensureActiveMediaInView, 100);
} else {
  window.addEventListener('DOMContentLoaded', () => {
    ensureActiveMediaInView();
    setTimeout(ensureActiveMediaInView, 100);
  }, { once: true });
}
